const API_URL = process.env.REACT_APP_API_URL || 'https://pmapi.acts-int.net';
//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Azure AD Configuration
const AZURE_AD_CLIENT_ID = '39bab26c-07fc-40a9-96a6-cf1ca61496a0';
const AZURE_AD_TENANT_ID = '283a68f4-93b3-4435-b14d-184be34fdf28';
const AZURE_AD_INSTANCE = 'https://login.microsoftonline.com/';
const AZURE_AD_REDIRECT_URI = window.location.origin + '/';
const AZURE_AD_AUTHORITY = AZURE_AD_INSTANCE + AZURE_AD_TENANT_ID;

// PKCE: generate code_verifier and code_challenge
function generateCodeVerifier() {
  var array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return Array.from(array, function(b) { return ('0' + b.toString(16)).slice(-2); }).join('');
}

async function generateCodeChallenge(verifier) {
  var encoder = new TextEncoder();
  var data = encoder.encode(verifier);
  var hash = await window.crypto.subtle.digest('SHA-256', data);
  var bytes = new Uint8Array(hash);
  return btoa(String.fromCharCode.apply(null, bytes))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

var pkceVerifier = generateCodeVerifier();
generateCodeChallenge(pkceVerifier).then(function(challenge) {
  sessionStorage.setItem('__pkce_verifier__', pkceVerifier);

  window.__AZURE_AD_AUTHORIZE_URL = AZURE_AD_AUTHORITY + '/oauth2/v2.0/authorize' +
    '?client_id=' + AZURE_AD_CLIENT_ID +
    '&response_type=code' +
    '&redirect_uri=' + encodeURIComponent(AZURE_AD_REDIRECT_URI) +
    '&scope=openid profile email' +
    '&response_mode=query' +
    '&code_challenge=' + challenge +
    '&code_challenge_method=S256' +
    '&nonce=' + Math.random().toString(36).substring(2, 15);
});

export default API_URL;
export { AZURE_AD_CLIENT_ID, AZURE_AD_TENANT_ID };
export function getAzureAdAuthorizeUrl() {
  return window.__AZURE_AD_AUTHORIZE_URL || '';
}